import styled from 'styled-components';
import { ensurePxUnit } from '../utils/mobileUtils';

export const PageWrapper = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: ${({ gapSize }) => ensurePxUnit(gapSize)};
  max-width: ${({ maxWidth }) => ensurePxUnit(maxWidth)};
`;

export const PlaceholderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  color: #888;
  border: 2px dashed #ddd;
  border-radius: 8px;
  min-height: 150px;
  height: 100%;
`;


export const PlaceholderText = styled.p`
  margin: 0 0 15px 0;
  font-size: 1.1em;
`;

